import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      login: (email, password) => {
        // Simple authentication - in production this would be a real API call
        if (email === 'test@test.com' && password === '123') {
          const user = { id: 1, email: 'test@test.com' };
          set({ user });
          return { success: true, user };
        }
        return { success: false, error: 'Ungültige Anmeldedaten' };
      },
      logout: () => {
        set({ user: null });
      },
      isAuthenticated: () => {
        return !!get().user;
      }
    }),
    {
      name: 'auth-storage',
    }
  )
);

export { useAuthStore };